
export const SET_MSG = 'TRABALHADORES_MSG';
export const SET_EDITAR = 'TRABALHADORES_EDITAR';
export const SET_LISTA = 'TRABALHADORES_LISTA';
export const SET_TRABALHADORES = 'LISTA_TRABALHADORES';
export const SET_SALARIOBASE = 'TRABALHADORES_SALARIOBASE';